export function removeStyleTagsInElements() {
    for (let element of document.querySelectorAll('.imgTextElement__imgWrapper')) {
        for (let styleTag of element.querySelectorAll('style')) {
            styleTag.remove();
        }
    }
}